var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThinArrow = function SvgThinArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 40.8 0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"
  })));
};
export default SvgThinArrow;